import { createWebHistory, createRouter } from 'vue-router';
import { useProfileOptions } from '@src/hooks';
import { ConfigService } from '@src/services';
import {
  LoginPage,
  MainPage,
  WelcomePage,
  HomePage,
  ForbiddenPage,
  ErrorPage,
  DeviceInfoPage,
  SettingsPage,
} from '@src/pages';

const routes = [
  { name: 'Welcome', path: '/welcome', component: WelcomePage },
  { name: 'Login', path: '/login', component: LoginPage },
  { name: 'Main', path: '/main', component: MainPage },
  { name: 'Forbidden', path: '/403', component: ForbiddenPage },
  { name: 'Error', path: '/error', component: ErrorPage },
  { name: 'DeviceInfo', path: '/device-info', component: DeviceInfoPage },
  { name: 'Home', path: '/', component: HomePage },
  { name: 'Settings', path: '/settings', component: SettingsPage },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = ConfigService.getToken();
  const { hasLogin } = useProfileOptions();

  if ((!token || hasLogin()) && !to.path.includes('login')) {
    return next('/login');
  }

  next();
});

export { router };